import React from 'react';
import { formatHours } from './timesheetUtils';

const TimesheetStats = ({ isLoading, stats, t, theme }) => {
  const items = [
    { key: 'today', label: t('today') || 'Today', value: stats.today },
    { key: 'week', label: t('thisWeek') || 'This Week', value: stats.week },
    { key: 'month', label: t('thisMonth') || 'This Month', value: stats.month },
  ];

  return (
    <div className="timesheets-stats" aria-busy={isLoading}>
      {items.map((item) => (
        <div
          key={item.key}
          className="timesheets-stat"
          style={{ background: theme.background, borderColor: theme.border }}
        >
          <span className="timesheets-stat-label" style={{ color: theme.secondaryText }}>
            {item.label}
          </span>
          <strong className="timesheets-stat-value">{isLoading ? '...' : formatHours(item.value)}</strong>
          <span className="timesheets-stat-unit" style={{ color: theme.secondaryText }}>
            {t('hours') || 'Hours'}
          </span>
        </div>
      ))}
    </div>
  );
};

export default TimesheetStats;
